module.exports = {"apiUrl":"https://api.echeckpoint.com/api","engineUrl":"https://engineapi.echeckpoint.com/api","supportEmail":"support@echeckpoint.com"};